import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import './App.css';
import LoginBox from './components/LoginBox';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ChangePasswordBox from './components/ChangePasswordBox';
import ForgotPasswordBox from './components/ForgotPasswordBox';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
// import NotFound from './components/NotFound';
import config from './config'
import ConfirmOTP from './components/ConfirmOTP';
import OTPLoginBox from './components/OTPLoginBox';
import HealthCheck from './components/HealthCheck';
// import SignUpBox from './components/SignUpBox';

class App extends Component {
  render() {
    const path = encodeURIComponent(config.SITE_URL);
    return (
      <BrowserRouter>
        <MuiThemeProvider>
          <div className="App">
            <Switch>
              <Route path={`/signin/:name/v1`} exact component={LoginBox} />
              <Route path="/signin/user/v1/forgotPassword" component={ForgotPasswordBox} />              
              <Route path="/signin/user/v1/passwordReset" component={ChangePasswordBox} />
              <Route path="/signin/user/v1/loginViaOTP" component={OTPLoginBox} />
              <Route path="/signin/user/v1/confirmOTP" component={ConfirmOTP} />
              <Route path="/health-check" component={HealthCheck} />
              <Redirect to={`/signin/user/v1?service=admin&redirectUrl=${path}`} />
            </Switch>
          </div>
        </MuiThemeProvider>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js